import React, { useEffect, useRef, useState } from 'react'
import styles from './style/new_arrivals_style.module.scss'
import Typography from '../../design-system/foundations/typography/Typography'
import ProductCard from '../../design-system/moleculars/product-card/ProductCard'
import Button from '../../design-system/basics/button/Button'
import Switch from '../../design-system/basics/switch/Switch'
import Cell from '../../design-system/foundations/grid/Cell'
import Grid from '../../design-system/foundations/grid/Grid'
import Carousel from '../../design-system/basics/carousel/Carousel'
import LocalizedLink from '../../global/LocalizedLink'
import Translation from '../../global/Translation'
import PnSpinner from '../PnSpinner'

const getCells = (colors, hasBigCard, centerId, updateProduct) => {
    const cells = []
    let grid;
    let index = 0
    let limit = colors.length

    if (hasBigCard) {
        --limit
        grid = (
            <React.Fragment>
                <Cell col-4 className={styles['new-arrivals-cards-column']}>
                    <div>
                        <ProductCard key={`new-arrivals-${index}`}
                                     colors={colors[index++]}
                                     centerId={centerId}
                                     fit
                                     footerClass={styles['new-arrivals-cards-footer']}
                                     index={index}
                                     updateProduct={updateProduct}
                                     list='PN-NEW-ARRIVALS'
                        />
                    </div>
                </Cell>
                <Cell col-8 className={styles['new-arrivals-cards-column']}>
                    <div>
                        <Grid className='p-0'>
                            {cells}
                        </Grid>
                    </div>
                </Cell>
            </React.Fragment>
        )
    }

    while (index < limit) {
        cells.push(
            <Cell {...hasBigCard ? { 'col-6' : true } : { 'col-4' : true }} className={styles['new-arrivals-cards-column']}>
                <ProductCard key={`new-arrivals-${index}`}
                             colors={colors[index++]}
                             centerId={centerId}
                             index={index}
                             updateProduct={updateProduct}
                             list='PN-NEW-ARRIVALS'
                />
            </Cell>
        )
    }

    return hasBigCard ? grid : cells;
}

const NewArrivals = (props) => {

    const [newestColors, setNewestColors] = useState(null)
    const [hasBigCard, setHasBigCard] = useState(false)
    const products = []

    useEffect(() => {
        props.fetchNewest()
    }, [])

    useEffect(() => {
        if (props.newestColors && props.newestColors.length > 0) {
            setNewestColors(props.newestColors)
        }
    },[props.newestColors])

    useEffect(() => {
        return props.updateSection && props.updateSection(props.id, products)
    }, [newestColors])

    const updateProduct = (id, product) => {
        products[id] = product
    }


    return (
        <div className={styles['new-arrivals']}>
            <div className={styles['new-arrivals-header']}>
                <Typography className={styles['new-arrivals-title']} typeface="title-xl-light">
                    <Translation id="discover_newest" defaultMessage="DISCOVER THE NEWEST"/>
                </Typography>

                <LocalizedLink routeId='ROUTE_CATALOG'
                               queryString='?brand[0]=SCALEA&brand[1]=SENSA&type[0]=SLAB&sort=creationDate_desc'
                               params={{'outlet': 'hq'}}
                >
                    <Button style-link
                            size-m
                            img={props.languageDir === 'rtl' ? "arrow_short_inverse" : "arrow_short"}
                            hImg={props.languageDir === 'rtl' ? "arrow_large_inverse" : "arrow_large"}
                            gtmLabel="item-list_button_view-all-new-natural-stone"
                    >
                        <Translation id="view_all_new_arrivals" defaultMessage="View all new arrivals"/>
                    </Button>
                </LocalizedLink>

                {/*Lo dejamos desactivado hasta que tengamos imágenes de ambiente*/}
                {/*<Switch img1="view_1"*/}
                {/*        img2="view_2"*/}
                {/*        onClickA={() => {setHasBigCard(true)}}*/}
                {/*        onClickB={() => {setHasBigCard(false)}}*/}
                {/*        className={styles['new-arrivals-switch']}*/}
                {/*/>*/}
            </div>

            {props.loadingNewestColors && <PnSpinner />}

            {newestColors && newestColors.length > 0 &&
                <React.Fragment>
                    <div id={props.id} className={styles['new-arrivals-cards-desktop']}>
                        <Grid className="p-0">
                            {getCells(newestColors, hasBigCard, props.centerId, updateProduct)}
                        </Grid>
                    </div>
                    <div id={props.id} className={styles['new-arrivals-cards-mobile']}>
                        <Carousel items={newestColors.map((colors, index) =>
                            <ProductCard key={`${colors.family}-${colors.brand}-${colors.colorId}`}
                                         colors={colors}
                                         centerId={props.centerId}
                                         index={index}
                                         updateProduct={updateProduct}
                                         list='PN-NEW-ARRIVALS'
                            />
                        )} />
                    </div>
                </React.Fragment>
            }
        </div>
    )
};

export default NewArrivals;